import {ThemeProvider} from "@mui/material";
// import { LicenseInfo } from "@mui/x-license";
import {Navigate, Route, BrowserRouter as Router, Routes} from "react-router-dom";
import OidcCallback from "./components/Auth/OidcCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import {IdentityAuthProvider} from "./context/IdentityAuthContext";
import MainLayout from "./layouts/MainLayout";
import Acceso from "./pages/Acceso/Acceso";
import ClientDetail from "./pages/ClientDetail";
import Clients from "./pages/Clients";
import Dashboard from "./pages/Dashboard";
import M2MTokens from "./pages/M2MTokens";
import M2MTokenDetail from "./pages/M2MTokenDetail";
import RoleDetail from "./pages/RoleDetail";
import Roles from "./pages/Roles";
import ScopeDetail from "./pages/ScopeDetail";
import Scopes from "./pages/Scopes";
import Tokens from "./pages/Tokens";
import Tickets from "./pages/Tickets";
import UserDetail from "./pages/UserDetail";
import Users from "./pages/Users";
import {darkTheme, lightTheme} from "./styles/theme";
import ProtectedLayout from "./layouts/ProtectedLayout";
import {useThemeStore} from "./stores/useThemeStore";
import {SnackbarProvider} from "notistack";
import SnackbarCopy from "./components/Notifications/SnackbarCopy";
import Tenants from "./pages/Tenants";
import Products from "./pages/Products";
import TenantDetail from "./pages/TenantDetail";
import ProductDetail from "./pages/ProductDetail";
import ScopesPreview from "./pages/ScopesPreview";

import UsuariosPanel from "./pages/UsuariosPanel";

function App() {
  const AUTH_ALLOWED_ROLES = process.env.REACT_APP_AUTH_ALLOWED_ROLES.split(",");
  // Comentamos la configuración de licencia para usar la versión community
  // const LICENSE_KEY = process.env.REACT_APP_DATAGRID_PRO_LICENSE_KEY;
  // LicenseInfo.setLicenseKey(LICENSE_KEY);

  const {mode} = useThemeStore();

  return (
    <IdentityAuthProvider>
      <ThemeProvider theme={mode === "dark" ? darkTheme : lightTheme}>
        <SnackbarProvider
          maxSnack={3}
          preventDuplicate
          anchorOrigin={{vertical: "top", horizontal: "right"}}
          style={{zIndex: 99999}}
          Components={{
            copy: SnackbarCopy
          }}
        >
          <Router>
            <Routes>
              {/* Rutas de OpenID Connect - deben estar fuera del layout */}
              <Route path="/callback" element={<OidcCallback />} />

              {/* Ruta de acceso */}
              <Route path="/acceso" element={<Acceso />} />

              {/* ZONA PROTEGIDA */}
              <Route element={<ProtectedLayout roles={AUTH_ALLOWED_ROLES} />}>
                <Route path="/" element={<MainLayout />}>
                  {/* Ruta por defecto */}
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="login" element={<Navigate to="/dashboard" replace />} />
                  {/* Rutas protegidas */}
                  <Route
                    path="dashboard"
                    element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    }
                  />
                  {/* AUTH SERVICE */}
                  <Route
                    path="users"
                    element={
                      <ProtectedRoute scope="identity.users.global.read">
                        <Users />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="tenants"
                    element={
                      <ProtectedRoute scope="identity.tenants.global.read">
                        <Tenants />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="tenant-form"
                    element={
                      <ProtectedRoute scope="identity.tenants.global.read">
                        <TenantDetail />
                      </ProtectedRoute>
                    }
                  />
                  {/* COMPONENTES */}
                  <Route
                    path="product-form"
                    element={
                      <ProtectedRoute scope="identity.products.global.read">
                        <ProductDetail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="products"
                    element={
                      <ProtectedRoute scope="identity.products.global.read">
                        <Products />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="roles"
                    element={
                      <ProtectedRoute scope="identity.roles.global.read">
                        <Roles />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="role-form"
                    element={
                      <ProtectedRoute scope="identity.roles.global.read">
                        <RoleDetail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="user-form"
                    element={
                      <ProtectedRoute scope="identity.users.global.read">
                        <UserDetail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="scope-form"
                    element={
                      <ProtectedRoute scope="identity.scopes.global.read">
                        <ScopeDetail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="scopes"
                    element={
                      <ProtectedRoute scope="identity.scopes.global.read">
                        <Scopes />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="scopes-preview"
                    element={
                      <ProtectedRoute scope="identity.scopes.global.read">
                        <ScopesPreview />
                      </ProtectedRoute>
                    }
                  />
                  {/* SEGURIDAD */}
                  <Route
                    path="/clients"
                    element={
                      <ProtectedRoute scope="identity.clients.global.read">
                        <Clients />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="client-form"
                    element={
                      <ProtectedRoute scope="identity.clients.global.read">
                        <ClientDetail />
                      </ProtectedRoute>
                    }
                  />
                  {/* Usuarios Panel */}
                  <Route
                    path="/usuarios-panel"
                    element={
                      <ProtectedRoute scope="identity.users.tenant.read">
                        <UsuariosPanel />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/tokens"
                    element={
                      <ProtectedRoute scope="identity.tokens.global.read">
                        <Tokens />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/m2m-tokens"
                    element={
                      <ProtectedRoute scope="identity.m2m_tokens.global.read">
                        <M2MTokens />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="m2m-tokens-form"
                    element={
                      <ProtectedRoute scope="identity.m2m_tokens.global.read">
                        <M2MTokenDetail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/tickets"
                    element={
                      <ProtectedRoute scope={["identity.tickets.global.read", "identity.tickets.global.write"]}>
                        <Tickets />
                      </ProtectedRoute>
                    }
                  />
                </Route>
              </Route>
              <Route path="*" element={<Navigate to="/acceso" replace />} />
            </Routes>
          </Router>
        </SnackbarProvider>
      </ThemeProvider>
    </IdentityAuthProvider>
  );
}

export default App;
